import React, { useState, createContext, useContext } from 'react';
interface CartItem {
  name: string;
  price: string;
  image: string;
  quantity: number;
}
interface CartContextType {
  cart: CartItem[];
  addToCart: (product: {
    name: string;
    price: string;
    image: string;
  }) => void;
  removeFromCart: (name: string) => void;
  clearCart: () => void;
  totalItems: number;
}
const CartContext = createContext<CartContextType | undefined>(undefined);
export function CartProvider({
  children
}: {
  children: ReactNode;
}) {
  const [cart, setCart] = useState<CartItem[]>([]);
  const addToCart = (product: {
    name: string;
    price: string;
    image: string;
  }) => {
    setCart(prevCart => {
      const existingItem = prevCart.find(item => item.name === product.name);
      if (existingItem) {
        return prevCart.map(item => item.name === product.name ? {
          ...item,
          quantity: item.quantity + 1
        } : item);
      }
      return [...prevCart, {
        ...product,
        quantity: 1
      }];
    });
  };
  const removeFromCart = (name: string) => {
    setCart(prevCart => prevCart.filter(item => item.name !== name));
  };
  const clearCart = () => setCart([]);
  const totalItems = cart.reduce((sum, item) => sum + item.quantity, 0);
  return <CartContext.Provider value={{
    cart,
    addToCart,
    removeFromCart,
    clearCart,
    totalItems
  }} data-id="element-210">
      {children}
    </CartContext.Provider>;
}
export function useCart() {
  const context = useContext(CartContext);
  if (context === undefined) {
    throw new Error('useCart must be used within a CartProvider');
  }
  return context;
}